module.exports = __webpack_public_path__ + "static/footer-5-7413604bd3b0b580a0c48624bbd77f1d.jpg";